<template>
  <div>
    <tr-list request="/sysUerl/list" ref="trList" :data="params">
      <template slot="list" slot-scope="props">
        <div v-for="(item, index) in props.list" :key="index" @click="click(item)">
          {{item}}
        </div>
      </template>
    </tr-list>
  </div>
</template>

<script>
export default {
  name: 'test',
  data () {
    return {
      params: {

      },
      list: []
    }
  },
  components: {},
  methods: {
    click(item) {
      console.log(item)
    }
  },
  mounted () {
    console.log(this.$refs.trList.getList())
  }
}
</script>

<style lang="less" scoped>
</style>
